import { Application } from "pixi.js";
import { IWriteOnlyResourceManager, IReadOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import { ITransition } from "./ITransition";
import { ITransitionParams } from "./ITransitionFactory";
import * as PIXI from 'pixi.js';
import { CreateSpineResources, Delay, Geometry, Get, Log, LogGroup, Point, Rect, Safe, Scale, Size } from "../../MyHelpers";
import { Presentation, Settings } from "../../Settings";
import { ZIndex } from "../../ZIndex";
import { ISkeletonData, Spine } from "pixi-spine";
import { JSONResource } from "../../ResourceManager/JSONResource";
import { AtlasResource } from "../../ResourceManager/AtlasResource";
import gsap from "gsap";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { ITransitionParamsPIXIAPP } from "./ITransitionFactoryPIXIAPP";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { debug } from "svelte/internal";
import { Track } from "../../AudioManager";
import { FixedSizeCoverContainer, FixedSizeFitContainer, ResponsiveSizeContainer, ResponsiveView } from "../../../singlegame/ResponsiveHelpers";
import { JackpotDisplayProperties } from "../../JackpotDisplayProperties";
import { GetOrientation, Orientation } from "../../FitScreen";
import { TransitionAnimationSpine } from "./TransitionAnimationSpine";

export const TRANSITION_SIZE: Size = new Size(1920, 1080 * 3);

export class TransitionAnimationSpineResponsive extends TransitionAnimationSpine {


    public override OnResize(): void {
        if (!this.created) return;

        this.setToDefault();

        this.spine.pivot.set(TRANSITION_SIZE.Width / 2, (TRANSITION_SIZE.Height / 3) * 2);

        this.containertransitionViewApp?.setAvailableSize(window.innerWidth, window.innerHeight);
        this.transitionBackgroundContainer?.setAvailableSize(window.innerWidth, window.innerHeight);



        if (this.TitlePIXIAnimatedSprite) {
            // const scale = Math.min(scaleX, scaleY);this.transitionBackgroundContainer
            // this.TitlePIXIAnimatedSprite.scale.set(scale);
            this.TitlePIXIAnimatedSprite.position.x = (this.transitionFixedContainer.fixedWidth - this.TitlePIXIAnimatedSprite.width) / 2;
            this.TitlePIXIAnimatedSprite.position.y = (this.transitionFixedContainer.fixedHeight - this.TitlePIXIAnimatedSprite.height) / 2;
        }
        if (this.titleSpine) {
            this.titleSpine.position.x = (this.transitionFixedContainer.fixedWidth - this.titleSpine.width) / 2;
            this.titleSpine.position.y = (this.transitionFixedContainer.fixedHeight - this.titleSpine.height) / 2;
        }

        this.spine.position.x = this.transitionBackgroundFixedContainer.fixedWidth / 2;//(this.transitionBackgroundFixedContainer.fixedWidth / 2 - (TRANSITION_SIZE.Width) / 2);
        this.spine.position.y = 0;//this.transitionBackgroundFixedContainer.fixedHeight / 2;///(this.transitionBackgroundFixedContainer.fixedHeight - TRANSITION_SIZE.Height) / 2;


    }

    public override async PrepareResources(resourceManager?: IWriteOnlyResourceManager): Promise<void> {
        //Spine Prepare 				
        await super.PrepareResources(resourceManager);
    }

    public override async ResourcesLoaded(resourceManager?: IReadOnlyResourceManager): Promise<void> {
        let spineTextureJson = resourceManager.Get<JSONResource>(this.resid.ScopedResourceName(`TransitionAnimationSpineJSON`));
        let spineAsset = await PIXI.Assets.load(spineTextureJson.path);
        this.jsonSpine = spineAsset.spineData;

        if (Settings.PresentationType == Presentation.Image) {
            let spriteResource = resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add(this.params.bonusName))
            for (let decodedFrames of spriteResource?.sprite.shared.decodedFrames) {

                // baseTexture.width = this.textureSize.width;
                //baseTexture.height = this.textureSize.height;

                let symbolTexture = PIXI.Texture.from(decodedFrames);
                this.titleTexture.push(symbolTexture);
            }
        }
        //its using title for jackpot into spine version.
        else {
            //check which bonus was creating the transition for change the title spine.
            if (this.params.bonusName == "FreeGameBonus") {
                let spineTextureJson = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(`FreeGamesBonusTitleJson`));
                let spineAsset = await PIXI.Assets.load(spineTextureJson.path);
                this.skelentonDataSpine = spineAsset.spineData;
            } else {
                this.skelentonDataSpine = globalThis?.jackpotDisplayGlobalResponsive?.GetSpineSkeleton() ?? null;
            }
        }
    }

    protected override containertransitionViewApp: ResponsiveView = null;
    protected transitionResponsiveSizeContainer: ResponsiveSizeContainer = null;
    protected transitionFixedContainer: FixedSizeFitContainer = null;

    protected transitionBackgroundContainer: ResponsiveView = null;
    protected transitionBackgroundResponsiveSizeContainer: ResponsiveSizeContainer = null;
    protected transitionBackgroundFixedContainer: FixedSizeFitContainer = null;

    protected setToDefault(): void {

        this.spine.position.x = 0;
        this.spine.position.y = 0;
        this.spine.pivot.set(0, 0);
    }

    public override InternalCreate() {
        if (!this.created) {
            Log.Error(this.logGroup, `Create(): app not null, don't recreate`);
            return;
        }

        if (this.app == null) return

        this.containertransitionViewApp = new ResponsiveView(window.screen.availWidth, window.screen.availHeight, { color: 0x220000, name: 'responsive-view-transition' });
        this.containertransitionViewApp.interactive = false;
        this.containertransitionViewApp.interactiveChildren = false;
        this.app.addChild(this.containertransitionViewApp);
        this.containertransitionViewApp.zIndex = 1;
        this.containertransitionViewApp.parent.setChildIndex(this.containertransitionViewApp, 1);

        this.transitionResponsiveSizeContainer = new ResponsiveSizeContainer(0, 0, 1, 1, NaN, { color: 0x990000, name: 'transition-responsive-size-container' });
        this.containertransitionViewApp.addChild(this.transitionResponsiveSizeContainer);

        this.transitionFixedContainer = new FixedSizeFitContainer(Scale.W(1920), Scale.H(1080 * 3), { color: 0x990000, name: 'transition-fixed-size-container' });
        this.transitionResponsiveSizeContainer.addChild(this.transitionFixedContainer);

        this.transitionBackgroundContainer = new ResponsiveView(window.screen.availWidth, window.screen.availHeight, { color: 0x220000, name: 'responsive-view-transition-background' });
        this.app.addChild(this.transitionBackgroundContainer);

        this.transitionBackgroundResponsiveSizeContainer = new ResponsiveSizeContainer(0, 0, 1, 1, NaN, { color: 0x990000, name: 'transition-responsive-size-container-background' });
        this.transitionBackgroundContainer.addChild(this.transitionBackgroundResponsiveSizeContainer);

        this.transitionBackgroundFixedContainer = new FixedSizeCoverContainer(Scale.W(1920), Scale.H(1080), { color: 0x990000, name: 'transition-fixed-size-container-background' });
        this.transitionBackgroundResponsiveSizeContainer.addChild(this.transitionBackgroundFixedContainer);

        this.spine = CreateSpineResources(this.jsonSpine);

        console.log("spineCreated", this.spine);
        this.spine?.state?.addListener({
            complete: async () => {
                await Delay(1);
                this.DestroyTransitionPixi();
            },
            start: () => {
                //await Delay(1);
                this.OnTransitionStarted();
            }
        });

        // this.transitionFixedContainer.position.x = (this.transitionFixedContainer.fixedWidth - this.spine.width) / 2;
        // this.transitionFixedContainer.position.y = (this.transitionFixedContainer.fixedHeight - this.spine.height) / 2;
        // this.transitionFixedContainer.addChild(this.spine);
        this.transitionBackgroundFixedContainer.addChild(this.spine);


        if (this.skelentonDataSpine != null) {
            this.titleSpine = CreateSpineResources(this.skelentonDataSpine);
            gsap.set(this.titleSpine, { duration: 0.2, alpha: 0 });
            this.transitionFixedContainer.addChild(this.titleSpine);
        }
        else {
            this.TitlePIXIAnimatedSprite = new PIXI.AnimatedSprite(this.titleTexture);
            //this.TitlePIXIAnimatedSprite.x = Settings.ScreenWidth/2;
            gsap.set(this.TitlePIXIAnimatedSprite, { duration: 0.2, alpha: 0 });
            this.TitlePIXIAnimatedSprite.alpha = 0;
            // this.transitionFixedContainer.addChild(this.TitlePIXIAnimatedSprite);
            this.transitionFixedContainer.addChild(this.TitlePIXIAnimatedSprite);
        }
        this.OnResize();
    }

    public override DestroyTransitionPixi() {
        //this.Destroy()
        //this.updateMatter = false;
        if (!this.created) {
            Log.Debug(this.logGroup, `Destroy() FillingPot: no app, not destroying anything`);
            return;
        }
        this.created = false;
        Safe(() => { this.titleSpine?.state?.clearTracks() })
        Safe(() => { this.titleSpine?.state?.clearListeners() })
        Safe(() => { this.titleSpine?.destroy(); })
        Safe(() => { this.TitlePIXIAnimatedSprite?.destroy({ children: true }); });
        Safe(() => { this.spine?.state?.clearTracks(); })
        Safe(() => { this.spine?.state?.clearListeners(); });
        Safe(() => { this.containertransitionViewApp.destroy({ children: true }); });
        Safe(() => { this.transitionBackgroundContainer.destroy({ children: true }); });
        //Safe(() => { this.spine?.destroy() })  
        Safe(() => {
            this.containertransitionViewApp?.removeFromParent();
        });
        Safe(() => {
            this.containertransitionViewApp?.destroy();
        });

    };

}